export function view(action) {
  if (action?.document_tree_node?.name?.endsWith('.html')) {
    return 'Edit'
  } else if (action?.document_tree_node?.name?.endsWith('.pdf')) {
    return 'Preview'
  } else if (action) {
    return 'Generate'
  } else {
    return 'No'
  }
}
